import { render, staticRenderFns } from "./LaporanSaya.vue?vue&type=template&id=3b575928&"
import script from "./LaporanSaya.vue?vue&type=script&lang=js&"
export * from "./LaporanSaya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports